import { appEntry } from '@/mocks/homeData';

export default function AppEntrySection() {
  return (
    <section id="app" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 w-full lg:w-auto text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
                移动端
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                {appEntry.title}
              </h2>
              <p className="text-sm text-foreground-500 mb-1">{appEntry.subtitle}</p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                {appEntry.description}
              </p>
              <ul className="space-y-2 mb-6">
                {appEntry.features.map((feat) => (
                  <li
                    key={feat}
                    className="flex items-center justify-center lg:justify-start gap-2 text-sm text-foreground-700"
                  >
                    <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                    {feat}
                  </li>
                ))}
              </ul>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-wechat-line"></i>
                微信关注吃瓜官网
              </a>
            </div>

            <div className="flex-shrink-0">
              <div className="w-44 h-44 bg-background-100 rounded-2xl flex items-center justify-center border border-background-200/70">
                <div className="text-center">
                  <i className="ri-qr-code-line text-5xl text-foreground-400 mb-2 block"></i>
                  <span className="text-xs text-foreground-400">{appEntry.qrCodeText}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}